let useLocal = false



export const apiBaseUrl = useLocal ? "http://ryf.api.local/apix" : "https://ryf.api.zedixi.com/apix"
